

import styles from "./style";
import "./index.css"


import Home from "./pages/Home";

import Store from "./pages/Store";
import { Navigate, Route, Routes } from "react-router-dom";
import RoadMap from "./pages/RoadMap";
import RoadMapEngine from "./pages/RoadMapEngine";
import RoadMapMix from "./pages/RoadMapMix";
import RoadMapHealth from "./pages/RoadMapHealth";
import RoadMapBusiness from "./pages/RoadMapBusiness";


import Precios from "./pages/Precios";

import PoliticasClase from "./pages/PoliticasClase";
import Pagos from "./pages/Pagos";


import ContainerPortal from "./pages/ContainerPortal";


import RoadMapMed from "./pages/RoadMapMed";
import RoadMapDev from "./pages/RoadMapDev";
import RoadMapEnam from "./pages/RoadMapEnam";
import RoadMapFrench from "./pages/RoadMapFrench";
import RoadMapC1 from "./pages/RoadMapC1";
import Team from "./pages/Team";
import MebLanding from "./pages/myenglishbro/MebLanding";
import CambridgeExam from "./pages/CambridgeExam";
import Certificate from "./pages/Certificate";
import RoadMapC2 from "./pages/RoadMapC2";
import RoadMapUoe from "./pages/RoadMapUoe";
import RoadMapEg from "./pages/RoadMapEg";
import RoadMapB2CF from "./pages/RoadMapB2CF";
import GrammarCodeQuest from "./components/GrammarCodeQuest";
import FightingGrammar from "./components/FightingGrammar";
import EncryptTextUploader from "./components/EncryptTextUploader";
import KeywordTransformerTrainer from "./components/KeywordTransformerTrainer";
import CambridgeEncryptor from "./components/CambridgeEncryptor";
import TrainingCenter from "./components/TrainingCenter";
import TxtEncryptor from "./components/TxtEncryptor";
import MultipleChoiceTrainer from "./components/MultipleChoiceTrainer";
import GappedTextQuizUploader from "./components/GappedTextQuizUploader";
import ReadingEn from "./components/ReadingEn";
import WordReorderGame from "./components/WordReorderGame";
import ReadingComprehension from "./components/Aplicativos/ReadingComprehension.jsx";
import AudioListeningQuiz from "./components/AudioListeningQuiz";
import ConversationPracticeBot from "./components/ConversationPracticeBot.jsx";
import CreativeSlides from "./components/CreativeSlides.jsx";
import ReporteMensual from "./components/ReporteMensual.jsx";
import EducationalAppsShowcase from "./components/EducationalAppsShowcase.jsx";
import SixtyType from "./components/SixtyType.jsx";
import RoadMapKeyMastery from "./pages/RoadMapKeyMastery.jsx";
import PetVisualizador from "./components/PetVisualizador.jsx";
import InicioA1 from "./components/Login/LoginA1/InicioA1.jsx";
import InicioA2 from "./components/Login/LoginA2/InicioA2.jsx";

import InicioB2 from "./components/Login/LoginB2/InicioB2.jsx";
import InicioiT from "./components/Login/LoginIt/InicioIt.jsx";
import IniciobB1 from "./components/Login/LoginB1/InicioB1.jsx";
import InicioJuan from "./components/Login/LoginJuan/InicioJuan.jsx";

import InicioB2C from "./components/Login/LoginB2C/InicioB2C.jsx";
import InicioC from "./components/Login/LoginCelpip/InicioCelpip.jsx";
import CELPIPSpeaking from "./components/Speaking/CELPIPSpeaking.jsx";
import SpeakingCayetano from "./components/Speaking/SpeakingCayetano.jsx";
import CELPIPSpeaking2 from "./components/Speaking/CELPIPSpeaking2.jsx";
import CELPIPSpeaking3 from "./components/Speaking/CELPIPSpeaking3.jsx";
import CELPIPSpeaking4 from "./components/Speaking/CELPIPSpeaking4.jsx";
import SpeakingPart3 from "./components/Speaking/SpeakingPart3.jsx";
import SpeakingPart4 from "./components/Speaking/SpeakingPart4.jsx";
import Quizbank01 from "./components/Aplicativos/Quizer/Quizbank01.jsx";
import InicioIelts from "./components/Login/LoginIelts/InicioIelts.jsx";
import UseOfEnglishSimulator from "./components/SimulatorB2/UseOfEnglishSimulator.jsx";
import KeywordTransformation from "./components/Aplicativos/kwt/KeywordTransformation.jsx";
import InicioC1 from "./components/Login/LoginC1/InicioC1.jsx";
import MultiLevelQuiz3 from "./components/Aplicativos/multiplechoicecloze/Multilevelquiz3.jsx";
import MultiLevelQuiz4 from "./components/Aplicativos/devs/Multilevelquiz4.jsx";
import Desafio01 from "./components/Aplicativos/presentsimpleduo/Desafio01.jsx";
import Desafio02 from "./components/Aplicativos/pastsimpleperfect/Desafio02.jsx";
import Desafio03 from "./components/Aplicativos/pastsimpleprogressive/Desafio03.jsx";

import UseOfEnglishInline from "./components/Aplicativos/uoe1/UseOfEnglishInline.jsx";
import UseOfEnglishInline2 from "./components/Aplicativos/uoe2/UseOfEnglishInline2.jsx";
import UseOfEnglishInline3 from "./components/Aplicativos/uoe3/UseOfEnglishInline3.jsx";
import InicioB2CFR from "./components/Login/LoginB2CF/InicioB2CFR.jsx";
import Essentialgrammar from "./components/Aplicativos/essentialgrammar/Essentialgrammar.jsx";
import VocabTrainer from "./components/Aplicativos/vocabulario/Vocabtrainer.jsx";
import InicioA1F from "./components/Login/loginA1F/InicioA1F.jsx";
import InicioB05 from "./components/Login/LoginB05/InicioB05.jsx";

function App() {
  return (
    

<div >

        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/Precios" element={<Precios />}></Route>
          <Route path="/Store" element={<Store />}></Route>
          <Route path="/Team" element={<Team />}></Route>

          <Route path="/A1" element={<InicioA1 />}></Route>
                   <Route path="/A1F" element={<InicioA1F />}></Route>

                    <Route path="/A2" element={<InicioA2 />}></Route>
                    <Route path="/B05C" element={<InicioB05 />}></Route>

          <Route path="/B1" element={<IniciobB1 />}></Route>
          <Route path="/ielts" element={<InicioIelts />}></Route>

          <Route path="/B2" element={<InicioB2 />}></Route>
         <Route path="/B2C" element={<InicioB2C />}></Route>
         <Route path="/B2CF" element={<InicioB2CFR />}></Route>

                  <Route path="/C1" element={<InicioC1 />}></Route>

          <Route path="/valere" element={<InicioiT />}></Route>
          <Route path="/108pv" element={<Quizbank01 />}></Route>
          <Route path="/simulator" element={<UseOfEnglishSimulator />}></Route>
          <Route path="/presentsimpleprogressive" element={<Desafio01 />}></Route>
          <Route path="/pastsimpleperfect" element={<Desafio02 />}></Route>
                    <Route path="/pastsimpleprogressive" element={<Desafio03 />}></Route>
                    <Route path="/essentialgrammar" element={<Essentialgrammar />}></Route>

           <Route path="/uoepart1" element={<UseOfEnglishInline />}></Route>
            <Route path="/uoepart2" element={<UseOfEnglishInline2 />}></Route>
           <Route path="/uoepart3" element={<UseOfEnglishInline3 />}></Route>
           <Route path="/uoepart4" element={<KeywordTransformation  />}></Route>

            <Route path="/uoe1-2" element={<MultiLevelQuiz3 />}></Route>
                        <Route path="/uoepart5" element={<ReadingComprehension  />}></Route>

            {/* Old URLs keep working for links that were already shared */}
            <Route path="/uoe1" element={<Navigate to="/uoepart1" replace />}></Route>
            <Route path="/uoe2" element={<Navigate to="/uoepart2" replace />}></Route>
            <Route path="/uoe3" element={<Navigate to="/uoepart3" replace />}></Route>
            <Route path="/uoe4" element={<Navigate to="/uoepart4" replace />}></Route>
            <Route path="/uoe5" element={<Navigate to="/uoepart5" replace />}></Route>

      
          <Route path="/devs" element={<MultiLevelQuiz4 />}></Route>

          <Route path="/Celpip" element={<InicioC />}></Route>
          <Route path="/s-part1" element={<CELPIPSpeaking/>}></Route> 
            <Route path="/s-cayetano" element={<SpeakingCayetano/>}></Route>
          <Route path="/s-part2" element={<CELPIPSpeaking3 />}></Route>
          <Route path="/s-part3" element={<SpeakingPart3 />}></Route>
          <Route path="/s-part4" element={<SpeakingPart4 />}></Route>

                    <Route path="/task02" element={<CELPIPSpeaking2 />}></Route>

          <Route path="/task04" element={<CELPIPSpeaking4 />}></Route>

          <Route path="/RoadMap" element={<RoadMap />}></Route>
          <Route path="/CambridgeExam" element={<CambridgeExam />}></Route>
          <Route path="/KeywordMastery" element={<RoadMapKeyMastery />}></Route>

          <Route path="/s" element={<RoadMapB2CF />}></Route>

          <Route path="/RoadMapC1" element={<RoadMapC1 />}></Route>
          <Route path="/RoadMapC2" element={<RoadMapC2 />}></Route>
          <Route path="/RoadMapUoe" element={<RoadMapUoe />}></Route>
          <Route path="/RoadMapEg" element={<RoadMapEg />}></Route>

          <Route path="/RoadMapFrench" element={<RoadMapFrench />}></Route>

          <Route path="/RoadMapBusiness" element={<RoadMapBusiness />}></Route>
          <Route path="/RoadMapEngine" element={<RoadMapEngine />}></Route>
          <Route path="/RoadMapHealth" element={<RoadMapHealth />}></Route>
          <Route path="/RoadMapMix" element={<RoadMapMix />}></Route>
          <Route path="/Enam" element={<RoadMapEnam />}></Route>
          <Route path="/Certificate" element={<Certificate />}></Route>
          <Route path="/xd" element={<EducationalAppsShowcase  />}></Route>

          <Route path="/sixtytype" element={<SixtyType  />}></Route>
          <Route path="/mct" element={<MultipleChoiceTrainer  />}></Route>
          <Route path="/wo" element={<WordReorderGame  />}></Route>
          <Route path="/audio" element={<AudioListeningQuiz  />}></Route>
          <Route path="/conversa" element={<ConversationPracticeBot  />}></Route>
          <Route path="/slides" element={<CreativeSlides  />}></Route>
          <Route path="/report-attendance" element={<ReporteMensual  />}></Route>
          <Route path="/pet01" element={<PetVisualizador />}></Route>

                  <Route path="/maze" element={<GrammarCodeQuest  />}></Route>

                          <Route path="/fight" element={<FightingGrammar  />}></Route>
                  <Route path="/kwt" element={<KeywordTransformerTrainer  />}></Route>
                  <Route path="/tc" element={<TrainingCenter  />}></Route>
                  <Route path="/gt" element={<GappedTextQuizUploader  />}></Route>

                  <Route path="/encripreguntarespuesta" element={<EncryptTextUploader  />}></Route>
                  <Route path="/encrikeyword" element={<CambridgeEncryptor  />}></Route>
                  <Route path="/encri3" element={<TxtEncryptor  />}></Route>
                  <Route path="/readingencriptador" element={<ReadingEn  />}></Route>

          <Route path="/Plataforma" element={<InicioJuan />}></Route>

        
        
        
        
        
        
        
        
      
        
        
        
          <Route path="/RoadMapMed" element={<RoadMapMed />}></Route>
          <Route path="/Bootcamp" element={<RoadMapDev />}></Route>

          <Route path="/PoliticasClase" element={<PoliticasClase />}></Route>
          <Route path="/Pagos" element={<Pagos />}></Route>
          <Route path="/MyPortal" element={<ContainerPortal />}></Route>
          <Route path="/Myenglishbro" element={<MebLanding />}></Route>

          <Route path="/vocab" element={<VocabTrainer />}></Route>

          
          

        </Routes>
      

        <div className={`bg-primary ${styles.paddingX} ${styles.flexCenter}`}>
      <div className={`${styles.boxWidth}`}>
        
      </div>
    </div>
  </div>
      
   
  );
}

export default App;



